import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { RedoHorizontalTabs } from "@redotech/redo-web/arbiter-components/tabs/redo-horizontal-tabs";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useMemo, useState } from "react";
import { getPlatformConfig, PLATFORM_CONFIGS } from "./platforms";
import { ImportPlatform, ImportTab } from "./types";

const PLATFORM_OPTIONS: RedoListItem<ImportPlatform>[] = PLATFORM_CONFIGS.map(
  (config) => ({
    id: config.id,
    value: config.id,
    type: "text",
    text: config.displayName,
  }),
);

export const PlatformImportCard = memo(function PlatformImportCard({
  teamId,
}: {
  teamId: string | undefined;
}) {
  const [selectedPlatform, setSelectedPlatform] = useState<ImportPlatform>(
    ImportPlatform.GORGIAS,
  );
  const [selectedTab, setSelectedTab] = useState<ImportTab>(ImportTab.MACROS);

  const platformConfig = getPlatformConfig(selectedPlatform);

  const tabs = useMemo(
    () =>
      platformConfig?.tabs.map((tab) => ({ key: tab.key, label: tab.label })) ??
      [],
    [platformConfig],
  );

  const handlePlatformChange = (item: RedoListItem<ImportPlatform>) => {
    setSelectedPlatform(item.value);
    const newConfig = getPlatformConfig(item.value);
    if (newConfig && !newConfig.tabs.some((tab) => tab.key === selectedTab)) {
      setSelectedTab(newConfig.tabs[0].key);
    }
  };

  const selectedPlatformOption = PLATFORM_OPTIONS.find(
    (opt) => opt.value === selectedPlatform,
  );

  const ActiveTabComponent = platformConfig?.tabs.find(
    (tab) => tab.key === selectedTab,
  )?.component;

  return (
    <Card radius="sm" title="Operation guillotine: Platform import">
      <Text fontSize="sm" fontWeight="medium">
        It is HIGHLY recommended to double check all of these imports in the
        merchant dashboard to verify correctness before communicating to the
        merchant that the import is complete.
      </Text>
      <Flex dir="column" gap="lg" w="full">
        <Flex align="center" gap="md">
          <Text fontSize="sm" fontWeight="medium">
            Platform:
          </Text>
          <div style={{ width: "150px" }}>
            <RedoSingleSelectDropdownInput
              options={PLATFORM_OPTIONS}
              optionSelected={({ item }) => handlePlatformChange(item)}
              selectedItem={selectedPlatformOption}
              size="xs"
            />
          </div>
        </Flex>

        <RedoHorizontalTabs
          drawBottomLine
          pl="none"
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          size="sm"
          tabs={tabs}
        />

        {ActiveTabComponent && <ActiveTabComponent teamId={teamId} />}
      </Flex>
    </Card>
  );
});
